var React = require('react');

function DotMini (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"8","cy":"8","r":"6.5","fill":"white","stroke":"black","strokeWidth":"3"}));
}

DotMini.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = DotMini;

DotMini.default = DotMini;
